// helpers/enumToOptions.js
export const enumToOptions = (enumObj) => {
    return Object.keys(enumObj).map((key) => ({
      label: key, // Use the key as the label
      value: enumObj[key], // Use the corresponding value
    }));
  };
  